import { menuItems } from '@data';
import { affiliateTabs as tabs } from '@constants';
import { chain, find } from 'lodash';

const statusTabs = [tabs.ACTIVE, tabs.PENDING, tabs.UNAVAILABLE];

export const getValidStatus = (value) => {
  if (value === tabs.ALL || value === tabs.FAVORITE) return null;
  return statusTabs.includes(value) ? value : tabs.ACTIVE;
};

export const findMenu = (user, pathname) => {
  const items = chain(menuItems(user))
    .flatMap((item) => [item, ...(item.children || [])])
    .value();

  return find(items, { pathname });
};

export const withHttps = (url) => (!/^https?:\/\//i.test(url) ? `https://${url}` : url);
